import React, { useState, useEffect } from "react"
import { useNavigate, useMatch, useParams, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Spin } from "antd"
import { routes } from "router"
import { DocumentsAddedModal } from "../modal/DocumentsAdded"
import { DocumentsAdded } from "../index"
import { getGuideDigitalWaivers, getDigitalWaiverById } from "store/digital-waiver"
import { getTripList } from "store/trips"
import { useDevice } from "hooks/useDevice"

export const WaiverWindow = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const { isMobile } = useDevice()
  const { id } = useParams()
  const isNew = useMatch(routes.ProDigitalWaiverNew())
  const isEdit = useMatch(routes.ProDigitalWaiverEdit())
  const isView = useMatch(routes.ProDigitalWaiverView())
  const [isLoading, setIsLoading] = useState(false)
  const showList = location.state?.showList

  const items = useSelector((state) => state.digitalWaiver.items)
  const waiverFromStore = useSelector((state) => state.digitalWaiver.waiver)
  const needsWaiverData = isEdit || isView
  const storeItemMatch = needsWaiverData && id ? items.find((item) => String(item.id) === String(id)) || null : null
  const waiverDataFromStore = waiverFromStore?.data && typeof waiverFromStore.data === "object" ? waiverFromStore.data : waiverFromStore
  const fetchedWaiver = needsWaiverData ? waiverDataFromStore : null

  const initialData = storeItemMatch || (fetchedWaiver?.id && String(fetchedWaiver.id) === String(id) ? fetchedWaiver : null)

  // On hard reload the items list is empty — fetch the single waiver directly
  useEffect(() => {
    if (needsWaiverData && id && !storeItemMatch) {
      setIsLoading(true)
      dispatch(getDigitalWaiverById(id)).finally(() => setIsLoading(false))
    }
  }, [dispatch, needsWaiverData, id, storeItemMatch])

  const handleClose = () => navigate(-1)

  const handleSave = () => {
    dispatch(getGuideDigitalWaivers())
    dispatch(getTripList())
    handleClose()
  }

  if (!isNew && !isEdit && !isView) return null

  const shouldWaitForWaiverData = needsWaiverData && !initialData

  return (
    <>
      {showList && !isMobile && <DocumentsAdded />}
      {shouldWaitForWaiverData ? (
        <div className="w-full flex justify-center py-3xl">
          <Spin size="large" spinning />
        </div>
      ) : (
        <DocumentsAddedModal
          visible
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          initialData={initialData}
          isView={Boolean(isView)}
          onCancel={handleClose}
          onSave={handleSave}
        />
      )}
    </>
  )
}
